/* SXT V58: a small, requestAnimationFrame-limited parallax effect for the footer scene. */
if (!customElements.get('sxt-footer-scene')) {
  customElements.define('sxt-footer-scene', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window) || this.hasAttribute('data-static') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.ticking = false;
      this.update = this.update.bind(this);
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(this.update);
      };

      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.update();
        } else {
          window.removeEventListener('scroll', this.onScroll);
        }
      }, { rootMargin: '20% 0px' });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
    }

    update() {
      const rect = this.getBoundingClientRect();
      const travel = window.innerHeight + rect.height;
      const progress = Math.max(-1, Math.min(1, (window.innerHeight - rect.top) / travel * 2 - 1));
      this.style.setProperty('--sxt-footer-progress', progress.toFixed(3));
      this.ticking = false;
    }
  });
}
